import { render } from "./ProductOrder.vue?vue&type=template&id=99e9ab48&ts=true&lang=pug"
import script from "./ProductOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductOrder.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__